import { FormField, SearchField } from '@/components/custom/erp';
import { donViSearchColumns, QUERY_KEYS } from '@/constants';
import { Label } from '@/components/ui/label';
import { DonViCoSo } from '@/types/schemas';
import { FormMode } from '@/types/form';

interface OtherTabProps {
  searchFieldStates: {
    unit: DonViCoSo | null;
    setUnit: (unit: DonViCoSo | null) => void;
  };
}

export const OtherTab: React.FC<OtherTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='space-y-1'>
        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Đơn vị</Label>
          <SearchField<DonViCoSo>
            type='text'
            name='ma_don_vi'
            searchEndpoint={`/${QUERY_KEYS.DON_VI_TINH}`}
            searchColumns={donViSearchColumns}
            dialogTitle='Danh mục đơn vị cơ sở'
            columnDisplay='ma_unit'
            displayRelatedField='ten_unit'
            classNameRelatedField='w-full'
            value={searchFieldStates.unit?.ma_unit}
            relatedFieldValue={searchFieldStates.unit?.ten_unit}
            onRowSelection={searchFieldStates.setUnit}
          />
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Trạng thái</Label>
          <div className='w-[250px]'>
            <FormField
              type='select'
              name='status'
              options={[
                { value: 'ALL', label: 'Tất cả' },
                { value: '0', label: 'Chưa ghi sổ' },
                { value: '3', label: 'Chờ duyệt' },
                { value: '5', label: 'Đã ghi sổ' }
              ]}
              defaultValue={'1'}
            />
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-32 min-w-32'>Mã bộ phận</Label>
          <div className='w-[250px]'>
            <FormField
              type='select'
              name='user_id0'
              options={[
                { value: 'ALL', label: 'Tất cả' },
                { value: '1', label: 'Lọc theo người tạo' }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
